const CANONICAL_ACTOR_LABELS: Readonly<Record<string, string>> = {
  "system:nova-scheduler": "Nova scheduler",
}

/**
 * "Started by" values are provider-prefixed identities, e.g.
 * "google:filip.cuper@gymbeam.com" or "slack:U12345". Split the leading
 * provider from the human-readable handle so the UI can de-emphasise the
 * prefix while keeping the whole string searchable.
 */
export function splitActor(raw: string): { provider: string | null; handle: string } {
  const canonicalLabel = CANONICAL_ACTOR_LABELS[raw]
  if (canonicalLabel !== undefined) {
    return { provider: null, handle: canonicalLabel }
  }

  const separator = raw.indexOf(":")
  if (separator === -1) {
    return { provider: null, handle: raw }
  }
  return { provider: raw.slice(0, separator), handle: raw.slice(separator + 1) }
}
